var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.86,
    width: 1,
    height: 135.53,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.42 180.9 121.64 189.22 35.07 189.22 31.3 180.9 68.15 155.39 88.57 155.39 125.42 180.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.13 130.81 88.57 155.39 68.15 155.39 65.59 130.81 91.13 130.81",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.42 180.9 121.63 189.22 35.07 189.22 31.29 180.9 125.42 180.9",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.91,
    width: 1,
    height: 108.69,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.47 154.05 222.69 162.38 136.12 162.38 132.35 154.05 169.2 128.54 189.62 128.54 226.47 154.05",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.18 103.97 189.62 128.54 169.2 128.54 166.64 103.97 192.18 103.97",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.47 154.06 222.68 162.38 136.12 162.38 132.34 154.06 226.47 154.06",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,223.34l-9.87,15.91,4.9,3a4.45,4.45,0,0,1,2,4.19,24.74,24.74,0,0,0-.09,2.73,4.5,4.5,0,0,1-2.32,4.09l-5,2.71L47,272.51l5-2.71a4.4,4.4,0,0,1,4.57.25,26.71,26.71,0,0,0,2.54,1.57,4.37,4.37,0,0,1,2.26,4l-.18,5.73,18.72.58.17-5.75a4.39,4.39,0,0,1,2.54-3.84c.44-.21.87-.43,1.3-.66s.85-.47,1.26-.72a4.38,4.38,0,0,1,4.59,0l4.91,3,9.86-15.91-4.91-3.05a4.44,4.44,0,0,1-2-4.19,24.64,24.64,0,0,0,.09-2.72,4.5,4.5,0,0,1,2.33-4.09l5-2.71-8.85-16.5-5.06,2.71a4.47,4.47,0,0,1-4.68-.33c-.75-.52-1.53-1-2.32-1.43a4.41,4.41,0,0,1-2.37-4L82,216l-18.71-.59-.18,5.75a4.44,4.44,0,0,1-2.6,3.86c-.42.19-.83.4-1.24.62s-.81.45-1.2.69a4.46,4.46,0,0,1-4.67,0Zm14.14,12.88a15.34,15.34,0,1,1-5.41,17.88A15.34,15.34,0,0,1,62.64,236.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,68a2.62,2.62,0,0,1-1.29-2.43c0-.27,0-.54,0-.81s0-.55,0-.82A2.62,2.62,0,0,1,459,61.51l2.93-1.69-5.5-9.55L453.46,52a2.6,2.6,0,0,1-2.75-.1c-.46-.29-.93-.57-1.42-.82a2.63,2.63,0,0,1-1.45-2.33V45.34h-11v3.37A2.62,2.62,0,0,1,435.37,51c-.49.25-1,.53-1.42.82a2.6,2.6,0,0,1-2.75.1l-2.93-1.69-5.51,9.55,2.94,1.7A2.6,2.6,0,0,1,427,63.94c0,.27,0,.54,0,.81s0,.54,0,.81A2.62,2.62,0,0,1,425.7,68l-2.94,1.69,5.51,9.55,2.92-1.69a2.62,2.62,0,0,1,2.75.09,14.4,14.4,0,0,0,1.43.83,2.62,2.62,0,0,1,1.44,2.33v3.37h11V80.79a2.63,2.63,0,0,1,1.45-2.33,15.64,15.64,0,0,0,1.43-.83,2.6,2.6,0,0,1,2.74-.09l2.93,1.69,5.5-9.55Zm-16.64,5.79a9,9,0,1,1,9-9A9,9,0,0,1,442.33,73.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.92,318.86a2.63,2.63,0,0,1-1.3-2.24c0-.45,0-.89,0-1.34a4.08,4.08,0,0,1,.08-1.35,2.53,2.53,0,0,1,.66-1.17,5.22,5.22,0,0,1,1.12-.75l2.33-1.36v.05l-5.56-9.52.13,0-3.06,1.8a2.73,2.73,0,0,1-1.82.22,6.29,6.29,0,0,1-1.63-.78l-.76-.43a2.81,2.81,0,0,1-.75-.57,2.75,2.75,0,0,1-.76-1.7l0-3.55.23.23-11,.1.34-.33,0,3.56a3,3,0,0,1-1.58,2.46l-.75.45-.75.44a3.25,3.25,0,0,1-.94.4,3.1,3.1,0,0,1-2-.23l-3.1-1.77.6-.16-5.47,9.57-.18-.67,3.1,1.78a3.16,3.16,0,0,1,1.37,2.7l0,.88,0,.87a3.25,3.25,0,0,1-.14,1,3.07,3.07,0,0,1-1.23,1.65l-3.1,1.78.17-.63,5.46,9.57-.56-.15,3.11-1.75a3.07,3.07,0,0,1,2-.21,3.34,3.34,0,0,1,.91.39l.76.45.75.44a3.1,3.1,0,0,1,.78.61,2.92,2.92,0,0,1,.76,1.79l0,3.57-.27-.27,11,.11-.16.16,0-3.55a2.7,2.7,0,0,1,.74-1.66,6.83,6.83,0,0,1,1.5-1,6.65,6.65,0,0,1,1.61-.77,2.58,2.58,0,0,1,1.77.21l3.07,1.78-.07,0,5.54-9.53v0Zm0,0,2.93,1.68h0v0l-5.47,9.56,0,.05,0,0-3.08-1.75a2.5,2.5,0,0,0-1.68-.18A5.79,5.79,0,0,0,202,329a6.19,6.19,0,0,0-1.43,1,2.46,2.46,0,0,0-.65,1.53l0,3.54v.16h-.16l-11,.11h-.26V335l0-3.53a2.28,2.28,0,0,0-.62-1.39,2.6,2.6,0,0,0-.62-.47l-.78-.44-.78-.44a2.29,2.29,0,0,0-.71-.28,2.25,2.25,0,0,0-1.49.18l-3,1.79-.35.21-.21-.36-5.55-9.52-.23-.4.4-.23,3-1.77a2.12,2.12,0,0,0,.83-1.14,2.5,2.5,0,0,0,.1-.72l0-.9,0-.9a2.5,2.5,0,0,0-.1-.72,2.05,2.05,0,0,0-.84-1.12l-3-1.78-.43-.24.25-.42,5.54-9.52.23-.39.38.22,3,1.77a2.17,2.17,0,0,0,1.44.17,2.09,2.09,0,0,0,.69-.28l.78-.44.79-.44a2.42,2.42,0,0,0,.6-.45,2.17,2.17,0,0,0,.6-1.36l0-3.51v-.35h.33l11,.1H200v.23l0,3.53a2.44,2.44,0,0,0,.63,1.48,6.13,6.13,0,0,0,1.41,1,5.73,5.73,0,0,0,1.54.78,2.48,2.48,0,0,0,1.63-.17l3.09-1.73.08-.05,0,.08,5.47,9.57,0,0,0,0-2.34,1.34a4.88,4.88,0,0,0-1.11.74,2.44,2.44,0,0,0-.66,1.14,4,4,0,0,0-.09,1.34c0,.45,0,.9,0,1.34A2.63,2.63,0,0,0,210.92,318.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.28,324.65A9.28,9.28,0,1,1,201,308.93a9.38,9.38,0,0,1,2.6,6.69,9.31,9.31,0,0,1-9.28,9Zm0,0a8.78,8.78,0,0,0,8.77-9,8.79,8.79,0,0,0-8.78-8.53,8.78,8.78,0,1,0,0,17.56Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-79"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.76 437.76 85.57 437.52 140.38 437.43 250 437.27 359.62 437.43 414.43 437.52 469.24 437.76 414.43 438.01 359.62 438.1 250 438.26 140.38 438.1 85.57 438.01 30.76 437.76",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.48,
    y: 90.01,
    width: 165.8,
    height: 167.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.71,79.9c5.53-6.49,15-8.05,24.16-6.2S415,80.17,416,95.49c.82,12.44-3,24.57-3,38.45s15.71,47.69-9.43,64.19c-22.59,14.82-68.36,1.21-69.77-29.3-1.11-24.18,27.57-46.54,30.59-56.11S364.65,87,370.71,79.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.58,93.55c-.17,6.92-1.17,13.92-4,20.45a19.66,19.66,0,0,1-2.85,4.59c-1.11,1.4-2.29,2.72-3.47,4-2.38,2.59-4.73,5.16-7,7.83a71.37,71.37,0,0,0-11.06,17.39,54.68,54.68,0,0,0-4.39,20,47.21,47.21,0,0,1,.31-10.42,51.39,51.39,0,0,1,2.67-10.16,63.31,63.31,0,0,1,10.92-18.05c2.27-2.71,4.68-5.3,7.08-7.86s4.83-5,6.32-8a44,44,0,0,0,3.47-9.64A82.54,82.54,0,0,0,366.58,93.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,105.94c-.17,7.06-.62,14.11-.43,21.12a86.3,86.3,0,0,0,.88,10.43c.52,3.4,1.54,6.8,2.39,10.24s1.61,6.93,2.17,10.45a60.7,60.7,0,0,1,.68,10.69,37.92,37.92,0,0,1-2,10.55,26.81,26.81,0,0,1-5.89,8.94,28.27,28.27,0,0,0,5-9.24,37.63,37.63,0,0,0,1.38-10.28,90.46,90.46,0,0,0-3.26-20.67c-.8-3.43-1.82-6.83-2.31-10.44a68.13,68.13,0,0,1-.54-10.67A173.22,173.22,0,0,1,415.37,105.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,165.31c-23,25.32-41.77,37.48-60.27,37.48-17.59,0-55.17-42.71-57.93-48.34-2.38-4.86,28.47-31.45,33.21-28.14,8,5.54,33.66,37.61,36.38,37.76s12.74-6.47,36.87-17.77C381.92,139.45,395,147.76,379,165.31Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38,158.66C261,155,246.81,136.73,244,130.77s-9.62-23.7-5.27-26.31,6.75,2.42,6.75,2.42-1.69-7.94,2.93-10.17,8.1,5.72,8.1,5.72-1.14-8.28,3.62-10.18,6.94,6.7,6.94,6.7-1.4-7.53,3.18-7.44c5.51.11,6.52,14.28,10.11,20.63.81,1.44,18.59,28,18.59,28Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.88,98.22c.77,10.41,2.91,14.84,9,23.11.12.16-.09.37-.23.22-6.73-7.56-10.21-12.72-9.3-23.32C266.42,97.71,266.84,97.72,266.88,98.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.48,101.61c1.74,10.75,4,15.57,9.79,24.7.08.13-.13.28-.22.16-6.41-8.49-9.77-13.72-10.1-24.69C255.93,101.28,256.4,101.11,256.48,101.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8,107.34c2.44,10.29,4.71,15.68,11.45,23.82.16.2-.11.45-.28.27-7.68-7.64-10.56-14.35-11.47-24C245.44,106.79,245.65,106.69,245.8,107.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.88,142.68s-.23-13.09-1.6-18.82S291,98.67,286.59,101.23c-5.63,3.3-.37,16,3,21.9,0,0-13,7.64-11.23,17.58S306.88,142.68,306.88,142.68Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.34,102.64c-3,6.72,2,14.17,4.85,20.12a.61.61,0,0,1-.44.89c-5.26,3.57-11.63,10.12-11.71,16.82a.15.15,0,0,1-.3,0c-.89-7.2,4.84-14.16,10.84-17.69-3-6.07-7.67-13.75-3.3-20.2A0,0,0,0,1,285.34,102.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.34,156.71l18.48,34.48s25.06-24.33,29.06-34.48-.31-17.52-18.14-12.09A156.07,156.07,0,0,0,339.34,156.71Z",
    style: {
      fill: "#F3C37D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.09,184c-.91-1.87-1.71-3.8-2.66-5.66s-1.9-3.7-2.89-5.52c-2-3.68-4-7.37-6.08-11-1.18-2-2.42-4.06-3.71-6-.05-.09-.22,0-.17.07,3.39,7.59,7.5,14.86,11.6,22.08,1.19,2.09,2.54,4.08,3.78,6.14C362,184.16,362.14,184.07,362.09,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.88,156.71c-4,10.15-29.06,34.48-29.06,34.48L345.37,168l41.07-22.71C388.8,147.75,388.77,151.92,386.88,156.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,214.76s-10.16,24.32-6.57,42.82H449c-3.64-50.29-28.71-93.51-43.52-107.5-11.94-11.28-24.51-10.27-33.26-4.5-2.06,1.37-24.79,32.78-27.25,37.75C335.21,202.94,343.55,214.76,343.55,214.76Z",
    style: {
      fill: "#F3C37D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,144.1s-7,20.13-2.94,21.18c10.1,2.6,23.65-13.89,24.46-15.57.2-.43,1.1-11.7,1.77-20.47.43-5.64.76-10.25.76-10.25l-24.92,8.55.8,15.45Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.09,127.54l.8,15.45c5.07-.71,16.22-3.46,23.36-13.75.43-5.64.76-10.25.76-10.25l-3.12,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.53,105.91c-.3,7.85.48,14.2,2.39,18.42a21.41,21.41,0,0,0,18.59,12.54c3,.11,11.64-.68,17.89-5.44,4.86-3.7,7.79-10.37,9.45-22.1,3.8-26.82-8.47-35.84-20.56-36.92S354.53,78.85,353.53,105.91Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,99.93c.63-.09,1.21-.27,1.82-.41a3.13,3.13,0,0,0,1.79-.77,1,1,0,0,0,0-1.18,2.4,2.4,0,0,0-2.36-.53,3.52,3.52,0,0,0-2.19,1.27A1,1,0,0,0,360.46,99.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.13,100.6a17.85,17.85,0,0,1-1.82-.42,3,3,0,0,1-1.78-.78,1,1,0,0,1,0-1.18,2.39,2.39,0,0,1,2.37-.51A3.51,3.51,0,0,1,379.1,99,1,1,0,0,1,378.13,100.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.71,107.36c0-.07.14.09.14.17-.15,1.83,0,4,1.63,4.66,0,0,0,.11,0,.1C373.44,111.91,373.28,109.07,373.71,107.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.45,105.51c3-.08,2.92,5.87.16,5.95S373,105.58,375.45,105.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.62,105.84c.51.34,1,.94,1.64,1s1.28-.54,1.76-1.14c.05-.06.1,0,.1.07,0,1.14-.44,2.31-1.67,2.47s-1.9-.88-2.18-2C376.22,106,376.41,105.7,376.62,105.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.86,106.58c0-.07-.14.09-.14.16,0,1.85-.19,4-1.86,4.58-.05,0-.05.11,0,.1C363.91,111.14,364.21,108.32,363.86,106.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.22,104.65c-3-.23-3.21,5.72-.46,5.93S364.7,104.85,362.22,104.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,105c-.48.3-1,.85-1.53.87s-1.11-.65-1.5-1.28c0-.07-.09,0-.1.06-.07,1.14.25,2.33,1.34,2.6s1.76-.71,2.07-1.83C361.3,105.2,361.15,104.88,361,105Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.53,121.68c-.43.45-.85,1.06-1.51,1.14a5.13,5.13,0,0,1-2-.39.06.06,0,0,0-.08.09,2.5,2.5,0,0,0,2.38.92,2,2,0,0,0,1.39-1.68A.1.1,0,0,0,373.53,121.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,114.85s-.44,2.75-.46,4.05c0,.12.31.18.75.22,0,0,0,0,.05,0a6.17,6.17,0,0,0,6-2.18c.09-.12-.07-.26-.19-.18a9.36,9.36,0,0,1-5.67,1.5c-.08-.37.91-4.68.7-4.7a11.08,11.08,0,0,0-3,.61c.75-5.75,2.41-11.33,3.06-17.06,0-.2-.27-.27-.33-.09-2.16,5.72-3.16,12.32-4.09,18.23C362.74,116,365.44,115.07,366,114.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.12,118.44a6.82,6.82,0,0,0,2.56,2.32,3.1,3.1,0,0,0,1.84.26c1.37-.25,1.5-1.48,1.34-2.55a7.75,7.75,0,0,0-.48-1.66A8.82,8.82,0,0,1,367.12,118.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.68,120.76a3.1,3.1,0,0,0,1.84.26c1.37-.25,1.5-1.48,1.34-2.55A3.16,3.16,0,0,0,369.68,120.76Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.36,106.92c-2.95.09-11.32-7.27-12.84-21.41,0,0,2.25,12.6,3.37,14.37s-4.68-4.15-6.07-15.53c0,0-5.9,5.14-11.16,7.14s-8.55,2.26-9,1.9,7.28-3.58,9.2-6.24c0,0-13.73,8-20.29,9.08-.76.12.52-11.69,10.13-19.29s22.82-5.7,27.56-1.9c0,0,5.18.27,11.42,7.32S404.53,106.82,401.36,106.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.47,111.24s5.49-8.73,9.42-6.81.1,14.37-4.31,16.26a4.57,4.57,0,0,1-6.25-2.15Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.7,108c.08,0,.09.09,0,.12-3.09,1.43-4.6,4.44-5.62,7.53.89-1.22,2.13-1.92,3.75-.88.08.05,0,.19-.08.17a2.83,2.83,0,0,0-3,1.14,14.34,14.34,0,0,0-1.36,2.57c-.13.29-.65.17-.55-.16a.24.24,0,0,1,0-.08C398.56,114.37,401.41,108.59,405.7,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.15,155.57c11.08,12.79,42.14,59.09,34.94,71.6-6.91,12-22.58,15.38-31.6-.74C411,214.9,400.09,180.5,397.38,164,395.18,150.64,403.91,143.74,414.15,155.57Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.8,196.56l36.72-13.49s-20.61-28.21-30.1-33.58-17.39-2.13-14.49,16.28A154.92,154.92,0,0,0,403.8,196.56Z",
    style: {
      fill: "#F3C37D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,177.83c-2,.65-4,1.17-6,1.85s-3.92,1.37-5.86,2.1c-3.93,1.46-7.85,2.92-11.74,4.49-2.18.88-4.36,1.83-6.49,2.83-.1,0-.06.21,0,.18,8-2.3,15.76-5.36,23.48-8.41,2.24-.89,4.39-2,6.6-2.89C434.14,177.94,434.07,177.8,434,177.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.87,195.7a13.44,13.44,0,0,0-2.13.66c-1-2.17-3.37-11.71-3.92-14.16-1.1-4.88-2-9.81-3.15-14.69,0-.14-.27-.1-.25,0,.34,2.71.76,5.41,1.23,8.09-.5-1.28-1-2.57-1.39-3.88a.06.06,0,1,0-.11,0,39.75,39.75,0,0,0,1.67,4.78c.39,5,4.94,20.89,5.07,20.83a30.07,30.07,0,0,0,3-1.57C406,195.79,406,195.69,405.87,195.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.71,101.57l-10.45,44.61c-.45,1.31.22,2.36,1.5,2.34l19.95,4.06a3.7,3.7,0,0,0,3.14-2.42l10.45-44.61c.45-1.31-.22-2.36-1.5-2.33l-19.95-4.07A3.7,3.7,0,0,0,387.71,101.57Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.42,101.82,379,146.43c-.45,1.31.22,2.36,1.5,2.34l19.95,4.06a3.7,3.7,0,0,0,3.14-2.41L414,105.81c.45-1.32-.22-2.36-1.5-2.34L392.56,99.4A3.73,3.73,0,0,0,389.42,101.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,103.74a2,2,0,1,1-1.94-1.95A1.95,1.95,0,0,1,395.74,103.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.82,230.47c6.49,12,23.67,5.16,26.27-3.3,6.1-19.85,2.32-52.85-1.32-71.28-1.17-5.93-41.45,0-41.21,6.41C406.84,170.05,410.1,206.87,422.82,230.47Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.32,164.7a62.54,62.54,0,0,0,.36-26.62c-2.12-9.59-9.05-29.93-36.91-39-6.61-2.16-17.56-.55-8,6.89,6.76,5.29,12.64,6.6,16,10.4,0,0-13.68,3.7-15.58,10.4a129.23,129.23,0,0,0-3.73,17.88,27.37,27.37,0,0,0,3.28,1,26.59,26.59,0,0,0,3.86,16.68Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.19,129.25c-4.14-3-13-9.38-22.09-12-10.08-3-30.27-5.9-32.37,1.55-1.54,5.47,6.07,7.28,6.07,7.28s-8.6.54-8.91,5.78c-.28,4.78,5.69,5.83,5.69,5.83s-5.16,1.22-4.55,5.88c.74,5.59,11.45,2.11,17.1,7.13C406.4,151.8,444.19,129.25,444.19,129.25Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.76,128.38c-4.36-2.24-15.58-4.77-24.8-2.48-.21,0-.28.23-.08.23a103.58,103.58,0,0,1,24.86,2.34C420.79,128.49,420.81,128.4,420.76,128.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.5,138.46c-4-1.54-15.65-3.64-24.91-1-.21.06-.27.25-.07.24a109.86,109.86,0,0,1,25,.86A.05.05,0,0,0,417.5,138.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.14,222.11c-.3-1-.59-2-.91-2.91-.66-2-1.23-4-1.81-6-1.18-4-2.31-8.06-3.3-12.14a214.94,214.94,0,0,1-4.49-24.68c-.28-2.3-.52-4.6-.77-6.9s-.33-4.69-.77-7c0-.12-1.17-1.88-1.63-2.75a23.41,23.41,0,0,1-1.25-2.8,25.9,25.9,0,0,1-1.51-6.08.07.07,0,0,0-.13,0,19.72,19.72,0,0,0,.88,7,12.37,12.37,0,0,0,3.1,5c0,.3.07,4,.19,6.07s.31,4.14.54,6.2c.47,4.14,1.05,8.27,1.78,12.38A188.11,188.11,0,0,0,415,212.07c0,.13.09.26.13.39,0,.3,0,.6,0,.9a18.12,18.12,0,0,0,.18,2.21,20.86,20.86,0,0,0,1.07,4.27.08.08,0,1,0,.15,0,28.43,28.43,0,0,1-.72-4.4l-.18-1.52c.55,1.62,1.13,3.24,1.7,4.85.4,1.12.81,2.21,1.27,3.3s.82,2.15,1.36,3.16c0,.08.16,0,.14-.06C419.85,224.1,419.45,223.12,419.14,222.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.48 257.58 294.48 230.7 263.93 257.58 294.48 257.58",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.47,314.57c8.8,38.29,27,84.19,34.77,91.64,9.83,9.42,74.86,26.7,78.1,27.05,8,.81,24.13-57,15.57-58.25-13-1.88-60.36-4.45-63.19-7.36s-22.93-28.25-43.47-56.72C145.07,291.26,132,290.81,137.47,314.57Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9,430.14c.95.48,14.54,7.32,22.94,9.75,6.27,1.82,24.45,6.57,27.14-.14,1.84-4.56-8.53-8.61-15.79-11.64-3.83-1.6-8.55-5.6-7.42-8.06,2-4.3,11.83,0,18.31,3.78,12.53,7.28,29.22,20.39,36.87,14,2.89-2.4-.47-6.78-5.38-11.07,8,5,16.48,9.1,19.79,6.56,1.91-1.45,2-3.44.94-5.7,2.46.8,4.63.64,6.15-1,2.59-2.72,1.33-6.72-1.51-10.83a3.08,3.08,0,0,0,2.36-1.54c5.49-8.37-22-32.4-31.49-34.65-27.95-6.65-57.41-5.41-57.41-5.41C248.42,383,243.87,430.12,243.9,430.14Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,404.41a47.46,47.46,0,0,1,18.65,7.17c7.09,4.68,11.79,10.16,17.73,15.67a.17.17,0,0,1-.22.25c-2.83-2.62-14.57-12.48-17.6-14.72A45.26,45.26,0,0,0,285,404.52C284.91,404.51,284.93,404.39,285,404.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,392.54c7.35,2,14.88,4,21.7,7.52,7.46,3.8,13.3,10,19,16q5.18,5.37,10.11,11c.13.16-.08.41-.22.25q-8.74-9.24-18-18A59.82,59.82,0,0,0,303,396.83c-4.2-1.61-8.52-2.88-12.84-4.16C290.1,392.65,290.13,392.52,290.21,392.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.06,382.17c7.14,1.47,13.37,2.72,19.69,6.54,8.37,5.07,16.45,13.6,19.28,16.63,3.13,3.34,6.15,6.78,9.11,10.27.12.14-.12.36-.25.22a237,237,0,0,0-21.77-21.57,47.42,47.42,0,0,0-12.18-7.92,84.61,84.61,0,0,0-13.89-4.12S298,382.16,298.06,382.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.9,371.89l-20,63.36s-54.15-15.46-64-26.13-28.16-65.77-33.53-92.48,8.13-26,20.54-9.21,43.31,57.65,45,58.54S254.9,371.89,254.9,371.89Z",
    style: {
      fill: "#F3C37D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.9,371.89l-20,63.36s-54.15-15.46-64-26.13-28.16-65.77-33.53-92.48,8.13-26,20.54-9.21,43.31,57.65,45,58.54S254.9,371.89,254.9,371.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.7,407.1c2.43-7.47,4.91-14.92,7.05-22.48,1.22-4.29,2.46-8.59,3.64-12.89.05-.17-.22-.26-.28-.1-2.73,7.4-5.45,14.83-7.84,22.35s-4.82,15-7.1,22.47c-1.29,4.28-2.46,8.58-3.49,12.93,0,.08.12.13.15.05C224.81,422.12,227.26,414.62,229.7,407.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.59,426.54l-2.4-.84c-4.51-1.61-9.11-3.34-13.44-5.11-.56-.22-1.11-.45-1.65-.68-.87-.36-1.74-.73-2.58-1.1l-1.26-.55-.45-.2-1.3-.6c-1.72-.79-3.35-1.58-4.87-2.38l-1-.56a37.67,37.67,0,0,1-6.68-4.39c-.19-.17-.38-.34-.55-.51s-.35-.34-.5-.5c-9.9-10.67-28.16-65.77-33.53-92.48l-.18-.92,0-.2c-.36-2-.68-4.54-.94-7.26v0c-.75-13.29,5.54-15.46,13.31-9.62C168.94,340.21,198.61,408.9,207.59,426.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,437.18l-118,.62c.1-2.54,16.9-76.84,30.26-104.26,17.13-35.16,26-38,31.23-39.88,6.75-2.42,18.77-1.22,21.62.13,3.24,1.51,13.54,19.49,17.23,32.68C169.22,353,181.16,435.56,179.5,437.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.94,296.44s15,55.55,15.75,59.24c1.13,5.36,8.61,81.84,8.61,81.84l-82.25.28S77,367,90.36,336C104.94,302,116.94,296.44,116.94,296.44Z",
    style: {
      fill: "#F3C37D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.94,296.44s15,55.55,15.75,59.24c1.13,5.36,8.61,81.84,8.61,81.84l-82.25.28S77,367,90.36,336C104.94,302,116.94,296.44,116.94,296.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M145.69,294.65c.44,1.77,14.27,46.9,15.23,58.15,1.07,12.48,10.53,85,10.53,85h12s-17.37-104.19-22.14-115.2C151.55,300.13,145.69,294.65,145.69,294.65Z",
    style: {
      fill: "#F3C37D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.69,294.65c.44,1.77,14.27,46.9,15.23,58.15,1.07,12.48,10.53,85,10.53,85h12s-17.37-104.19-22.14-115.2C151.55,300.13,145.69,294.65,145.69,294.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.41,309.43C81.65,330.6,33.61,410.92,48.85,425.57s99.85-5.07,123.61-16.4c7.07-3.36-19.79-47.44-28.1-48.47-6.92-.85-42.28,15.32-43.31,13.29-1.15-2.3,4.47-19.27,13-50C123.84,288.57,110.15,300.07,101.41,309.43Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.48,346.48c17.18-2.4,22-.37,35.39-10.09,8.81-6.38,16.67-3.49,11.64,6.64-8.22,16.58-29.74,24.32-38,24.86Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,363s19.31-10.72,37.37-15.08c12.48-3,40.38-6.55,67.08,21,6.33,6.53,10.72,20.33-3.49,13.42-10.1-4.91-15-11.07-21.41-12.86,0,0,3.5,18.21-3.29,24.3a167.87,167.87,0,0,1-18.87,14.64,34.48,34.48,0,0,1-3.06-3.28s-6.88,5.09-19.82,3.85Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.59,347c6,3.11,18.51,9.92,26.83,19.06,9.25,10.16,24.32,32.2,16.75,39-5.54,4.95-12-3-12-3s4.31,10.43-1.68,13.8c-5.45,3.08-10.11-3.34-10.11-3.34s1.53,6.77-4.3,8.72c-7,2.34-9.06-12.24-18.21-16C178.78,404.34,183.59,347,183.59,347Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.07,374c5.13,3.85,14.55,15.58,17.15,27.73.06.28-.11.47-.22.23a134.87,134.87,0,0,0-17-27.87C197.92,374,198,374,198.07,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.09,383.63c4.09,3.78,13.26,16.3,15.47,28.71.05.28-.14.46-.23.21A144.57,144.57,0,0,0,188,383.71C187.94,383.65,188,383.58,188.09,383.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39,369.36c5.6,1.65,9.24,4.4,14,7.68a76.93,76.93,0,0,0,7.21,4.57c2.28,1.23,5.65,3.09,8.07,1.16,1.36-1.07,1.34-3,1-4.57a22.47,22.47,0,0,0-3.08-6.37c0-.08.07-.17.13-.1a32.51,32.51,0,0,1,3.36,5.68,7.46,7.46,0,0,1,.51,4.37c-.83,3.08-4.47,3.49-7,2.64a24.8,24.8,0,0,1-4.4-2.13c-1.36-.78-2.68-1.62-4-2.5-2.66-1.8-5.21-3.75-7.85-5.58a72.64,72.64,0,0,0-8-4.66A.1.1,0,0,1,213.39,369.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.12,389.06c-1.45-3.19-9.3-16.49-11.84-19.57a.08.08,0,0,1,.11-.11c4.37,4.14,11.38,15.13,13,18.65s3.48,7.93,3.48,11.8c0,5.85-3.88,7-5.31,7.25a7.56,7.56,0,0,1-5-.82,15.22,15.22,0,0,1-4.52-4.24c-.06-.08.05-.19.12-.11,2,2.31,5.4,4.58,8.57,4.16a5.28,5.28,0,0,0,3.62-1.95,6.91,6.91,0,0,0,.94-4.71A32.34,32.34,0,0,0,225.12,389.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,363l27.08,57S55,443.78,45.86,425.34s32-90.6,50.53-111.62c21.49-24.36,24.23-16.07,19.5,5.52-5,22.6-14.53,55.28-14.53,55.28Z",
    style: {
      fill: "#F3C37D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,363l27.08,57S55,443.78,45.86,425.34s32-90.6,50.53-111.62c21.49-24.36,24.23-16.07,19.5,5.52-5,22.6-14.53,55.28-14.53,55.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.17,389.69A119.49,119.49,0,0,1,101,374c3.21-1,6.45-1.95,9.69-2.88.1,0,.14.13,0,.16a152.63,152.63,0,0,0-16.59,6.46q-8.09,3.6-16,7.49c-3,1.47-5.92,3.08-8.86,4.65A.12.12,0,0,1,69.17,389.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.56,362.85c-.53.14-29.5,9.71-30.45,10.15.12-.44,5.32-15.84,6.1-18.1.07-.22.14-.45.22-.67.52-1,1.06-2,1.55-3,.62-1.31,1.24-2.64,1.85-4a0,0,0,0,0-.06,0l-2,3.87c-.31.59-.6,1.2-.89,1.81.51-1.59,1-3.19,1.49-4.8.78-2.55,1.48-5.13,2.17-7.71,0-.09-.1-.11-.13,0-1.54,4.49-3.22,8.93-4.77,13.42s-7.51,21-7.46,21,31.9-11.26,32.52-11.51A.21.21,0,0,0,133.56,362.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.51,400c-3-6.35-5.91-12.74-9.12-19-1.83-3.55-3.64-7.11-5.5-10.64-.07-.13-.31,0-.25.11,2.74,6.5,5.5,13,8.54,19.39s6,12.7,9.09,19q2.64,5.37,5.61,10.57c0,.07.16,0,.13,0C141.49,412.81,138.52,406.42,135.51,400Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.29,420.88c-1.06-1.76-2.4-4.28-3.53-6-.3-.45-.65-.36-.41.11.81,1.6,1.48,3.39,2.27,5-1.48.3-3,.56-4.46.87-1.72.36-3.43.73-5.15,1.08q-5.06,1-10.12,2-10.26,1.91-20.6,3.36a403.92,403.92,0,0,1-41.66,3.91c-3.9.14-7.81.21-11.71.16a112.81,112.81,0,0,1-11.52-.56c-.11,0-.13.17,0,.19a63.91,63.91,0,0,0,10,1.3c3.53.17,7.07.25,10.61.21,7-.08,14.07-.54,21.08-1.18,13.9-1.28,27.76-3.16,41.5-5.59q5.78-1,11.53-2.17c1.94-.39,3.87-.78,5.8-1.21S162.47,421.18,162.29,420.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.71,315.38c-7,1.93-19.53-8.42-24.65-17-.35-.59.34-6.95.81-14.72.27-4.71.45-10,.27-14.78,0-1,30.43,6.22,30.43,6.22s-2.6,10.18-2.24,18.56a11,11,0,0,0,.28,2,2.29,2.29,0,0,1,.06.32C151.42,299.69,152.48,313.51,145.71,315.38Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,269c1.7,8.08,7.48,27.53,23.58,27.3a19.14,19.14,0,0,0,3.08-.28,1.44,1.44,0,0,0,0-.33,13,13,0,0,1-.29-2c-.35-8.39,2.24-18.58,2.24-18.58S130.59,269.91,124,269Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.2,254.45c-.34,7.38,4.64,13.6,11.12,13.9s12-5.46,12.33-12.84-4.65-13.6-11.12-13.89S156.53,247.07,156.2,254.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.42,
    cy: 255.34,
    rx: 14.88,
    ry: 13.06,
    transform: "translate(-97.14 409.04) rotate(-87.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,230.59c-5.24,9.88-5.57,41.29.59,49.51C135.63,292,153.18,296.37,164,285c10.53-11.06,10.23-52,3.08-59.77C156.57,213.76,133.85,216,126.11,230.59Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23,254.87c0-.08-.17.11-.16.2.11,2.11-.11,4.55-2,5.29-.06,0-.05.13,0,.12C152.41,260.1,152.67,256.86,152.23,254.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29,252.71c-3.41-.18-3.52,6.65-.37,6.81S153.15,252.86,150.29,252.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.07,255.13c0-.08.16.11.16.19-.1,2.12.14,4.56,2,5.29.06,0,0,.13,0,.12C163.92,260.36,163.63,257.12,164.07,255.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,253c3.4-.21,3.56,6.62.4,6.81S163.14,253.12,166,253Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.23,247.25c1-.05,1.83-.26,2.78-.4a4.52,4.52,0,0,0,2.75-1,1.44,1.44,0,0,0,.1-1.76,3.57,3.57,0,0,0-3.47-1,5.22,5.22,0,0,0-3.41,1.65A1.54,1.54,0,0,0,147.23,247.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.21,248a25.76,25.76,0,0,1-2.7-.75A4.51,4.51,0,0,1,163.9,246a1.44,1.44,0,0,1,.11-1.76,3.6,3.6,0,0,1,3.58-.61,5.27,5.27,0,0,1,3.18,2.06A1.54,1.54,0,0,1,169.21,248Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,274.48c.5.5,1,1.19,1.76,1.27a5.68,5.68,0,0,0,2.28-.5.08.08,0,0,1,.09.11,2.83,2.83,0,0,1-2.7,1.11,2.27,2.27,0,0,1-1.64-1.9C148.13,274.45,148.29,274.4,148.37,274.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7,268.18a7.19,7.19,0,0,0,4.75,3.28,9,9,0,0,0,2.59.17,4,4,0,0,0,.5-.05l.46-.07a.53.53,0,0,0,.44-.46v0a1.62,1.62,0,0,0,0-.22h0v-.19c.07-1.63,0-4.11,0-4.11.59.31,3.61,1.73,3.57.88-.3-7.06-.64-14.9-2.43-21.85a.2.2,0,0,0-.39,0c0,6.79,1.24,13.53,1.37,20.35a12.86,12.86,0,0,0-3.38-1.09c-.23.07.31,4.79.22,5.52a.45.45,0,0,1,0,.08c-2.75.3-4.8-.56-7.42-2.44C150.74,267.87,150.57,268,150.7,268.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09,270.78a8.49,8.49,0,0,1-3.46,2.6,3.87,3.87,0,0,1-2.34.11c-1.68-.48-1.7-2-1.37-3.35a9.21,9.21,0,0,1,.79-2A11.08,11.08,0,0,0,157.09,270.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.63,273.38a3.87,3.87,0,0,1-2.34.11c-1.68-.48-1.7-2-1.37-3.35C151.73,270.36,153.5,271.62,153.63,273.38Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.18,252.77c2.06-.33,7-7.3,9.09-10.07s3.3-17.62,3.49-21a22.25,22.25,0,0,0-8.66,8.86C123.76,235,122.41,243.73,122.18,252.77Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.31,234a10.64,10.64,0,0,1-9.82,3.29,10.84,10.84,0,0,1-8.14-6.73c0-.11-.2-.05-.16.05a10.72,10.72,0,0,0,8.13,7.53,10.94,10.94,0,0,0,10.19-4A.13.13,0,0,0,160.31,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.15,207.38c-6.17-.06-11.93,3.17-14.32,7.29a11.94,11.94,0,0,0-1.4,7.74c0,.11.23.09.22,0a13.09,13.09,0,0,1,6.55-11.63,16.89,16.89,0,0,1,15-1.32,10.6,10.6,0,0,1,5.58,4.78c.12.23.58.1.49-.13C160.71,210.19,155.72,207.43,150.15,207.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,221.87a13.63,13.63,0,0,0-5.56-7.49c-3.71-2.46-8-2.25-12.24-1.95a.09.09,0,0,0,0,.18c3.62-.24,7.31-.28,10.57,1.53a13.34,13.34,0,0,1,6,6.69,13,13,0,0,1-5.9,16,13.24,13.24,0,0,1-10.46.73c-.14-.05-.24.14-.11.2a13.31,13.31,0,0,0,17.72-15.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88,236.64s-5.46-11.23-.34-17.43c2.9-3.51,12.08-2.71,12.08-2.71s3.15-5.17,10.83-6.64,16.74,3.34,16.74,3.34,7.46-3.91,14.16.25c9.35,5.8,7.63,20.29-2.15,24.61-6.86,3-15.8-3.26-15.8-3.26-.89.09-10.11,5.19-16.63-3.1,0,0-5.72,4.72-10.57,1.09A8,8,0,0,1,123.88,236.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.81,256.57s-5.19-11-10.08-9.36-2.18,16.86,2.72,19.72a5.42,5.42,0,0,0,7.65-1.63Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.61,251.54c-.08,0-.12.1,0,.14,3.42,2.12,4.77,5.87,5.51,9.64-.85-1.55-2.22-2.55-4.26-1.57a.12.12,0,0,0,.06.22,3.35,3.35,0,0,1,3.42,1.77,16.43,16.43,0,0,1,1.22,3.22c.12.36.74.28.68-.12a.29.29,0,0,0,0-.09C126.08,260.08,123.57,252.89,118.61,251.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.12 278.72 129.27 274.47 121.35 264.61 122.87 263.38 130.49 272.87 139.9 276.93 139.12 278.72",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.07,277.15c1-2.87,9-1.81,7.55,2.53S137.1,280,138.07,277.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58,246.91s-1.07-16.13,3.65-25c5.26-9.91,27.06-19.34,42-8.69,0,0-24.27-4.34-35.58,9.4-4.76,5.78-4.64,24.74-4.64,24.74Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.63,
    cy: 255.2,
    rx: 13.06,
    ry: 14.88,
    transform: "translate(-2.53 1.2) rotate(-0.57)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88,254.64c.07,7.39-5.12,13.43-11.6,13.49s-11.8-5.87-11.87-13.26,5.12-13.43,11.6-13.49S128.81,247.25,128.88,254.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.55,295.48l-7.05,17.8L121.32,290.9l-6.22,7.24s21.75,35.61,21.88,34l7.25-15.35,10.62,10.61-1-26.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.11,314.15c-.31-4.41-.49-8.86-1-13.25,0-.15-.26-.22-.3,0-.86,4.27.41,21.12.41,25.17l-.05,0c-.44-.46-9.84-9.33-9.93-9.19-1.57,2.44-6.9,13.61-7.26,14.63-3.44-5.66-18-27.95-22.1-33.3a.15.15,0,0,0-.26.15c3,6,21.9,35.41,22.16,35.33a174.62,174.62,0,0,0,7.59-16.22c1.59,1.93,11.07,11.95,11.1,11.29A138,138,0,0,0,155.11,314.15Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--call-button--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.84,248.68H361.91a11.32,11.32,0,0,1-11.31-11.31h0a11.31,11.31,0,0,1,11.31-11.31h30.93a11.31,11.31,0,0,1,11.31,11.31h0A11.31,11.31,0,0,1,392.84,248.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--IaQ7Yo--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.67,237.17a2,2,0,0,1,.34-1l.28-.41.59-.59.69-.5a8.56,8.56,0,0,1,3.12-1.21,19.82,19.82,0,0,1,7.75,0,8.34,8.34,0,0,1,3.08,1.19c.24.16.48.34.71.51l.58.58a7.74,7.74,0,0,1,.42.68,5.34,5.34,0,0,1,.24.74H381.4a.18.18,0,0,1-.19-.11,1.72,1.72,0,0,0-1.45-.93,34.47,34.47,0,0,0-4.43,0,1.7,1.7,0,0,0-1.44.92c0,.07-.07.12-.17.12h-5.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,240v-1.85h5c0,.11,0,.23,0,.36V240a.56.56,0,0,1-.64.64H369.3A.55.55,0,0,1,368.67,240Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.44,240.06c0-.63,0-1.26,0-1.88h4.95v.11c0,.58,0,1.17,0,1.75a.56.56,0,0,1-.62.62H382A.54.54,0,0,1,381.44,240.06Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 439,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.97,
    y: 438.7,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.87,
    y: 438.4,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.77,
    y: 438.11,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.67,
    y: 437.81,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.57,
    y: 437.52,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.47,
    y: 437.22,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.37,
    y: 436.92,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.26,
    y: 436.63,
    width: 6.86,
    height: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.81 446.05 257.39 446.05 257.39 440.6 338.81 438.33 338.81 446.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.27 424.56 283.87 424.56 305.24 324.5 439.64 324.5 418.27 424.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.24 424.56 288.84 424.56 310.21 324.5 444.61 324.5 423.24 424.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.03,
    cy: 368.73,
    rx: 8.99,
    ry: 7.68,
    transform: "translate(-151.98 349.03) rotate(-42.74)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.23 450.69 319.13 450.69 319.13 445.55 385.23 443.42 385.23 450.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.2 450.68 367.71 450.68 346.33 394.61 381.82 394.61 403.2 450.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.04 450.68 373.55 450.68 352.18 394.61 387.67 394.61 409.04 450.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.88,452.05H186.73c-5.81,0,2.6-16.56,23.83-22.91S261.58,445.84,254.88,452.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.14,452.05a20.68,20.68,0,0,1,.93-5.56,23.3,23.3,0,0,1,2.29-5.19,18.88,18.88,0,0,1,3.62-4.39,16,16,0,0,1,4.79-3c-.73.6-1.56,1-2.23,1.67l-1,.89-1,1a23.74,23.74,0,0,0-3.3,4.35,32.65,32.65,0,0,0-2.42,4.93A41.28,41.28,0,0,0,228.14,452.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.21,436.29A43.79,43.79,0,0,1,247.58,442a24.52,24.52,0,0,1,4.75,4.3,14.59,14.59,0,0,1,1.75,2.71,7.86,7.86,0,0,1,.8,3.09,8.89,8.89,0,0,0-1.23-2.86,14.34,14.34,0,0,0-1.9-2.43,33.75,33.75,0,0,0-4.75-4c-1.69-1.22-3.48-2.31-5.27-3.39-.9-.54-1.82-1.06-2.74-1.56S237.14,436.8,236.21,436.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.76,224.89A30.27,30.27,0,0,1,209.17,244L194,246.26l7.58-13.09a30,30,0,0,1-2.08-14.58,30.28,30.28,0,1,1,60.23,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.76,224.89a30.43,30.43,0,0,1-6.11,15.35,34.28,34.28,0,0,1-2.74,3.16,35.69,35.69,0,0,1-3.2,2.7,29.53,29.53,0,0,1-7.3,4.07,30.1,30.1,0,0,1-8.15,1.94,28.19,28.19,0,0,1-4.21.08,26.69,26.69,0,0,1-4.19-.43,30.6,30.6,0,0,1-15-7.4l.36.11-15.13,2.33L193,247l.55-1,7.54-13.13,0,.52a30.58,30.58,0,1,1,58.7-8.5Zm0,0a30,30,0,0,0-34.33-32.77,29.75,29.75,0,0,0-12.51,4.94,31.35,31.35,0,0,0-9.06,9.88A30,30,0,0,0,200,219.76,30.36,30.36,0,0,0,202.15,233l.11.27-.15.24-7.62,13.07-.54-.8,15.16-2.12.21,0,.15.14a29.85,29.85,0,0,0,14.5,7.47,26.83,26.83,0,0,0,4.11.5,30.11,30.11,0,0,0,4.14,0,29.6,29.6,0,0,0,8.09-1.78,28.3,28.3,0,0,0,7.3-3.93,37.09,37.09,0,0,0,3.2-2.67,34,34,0,0,0,2.75-3.13A30.39,30.39,0,0,0,259.76,224.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.53,222.66a3.67,3.67,0,1,1-3.67-3.66A3.66,3.66,0,0,1,246.53,222.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.39,222.66a3.67,3.67,0,1,1-3.66-3.66A3.66,3.66,0,0,1,233.39,222.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.26,222.66a3.67,3.67,0,1,1-3.67-3.66A3.67,3.67,0,0,1,220.26,222.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.59,67.87A30.28,30.28,0,0,0,323.18,87l15.14,2.22-7.57-13.09a30.28,30.28,0,1,0-58.16-8.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.65,42.86A30.22,30.22,0,0,1,307,34.44a30.53,30.53,0,0,1,12.92,4.85,30.64,30.64,0,0,1,11.35,37.08l0-.52L338.79,89l.55,1-1.09-.17-15.14-2.32.36-.11a30.6,30.6,0,0,1-15,7.4,26.69,26.69,0,0,1-4.19.43,29.45,29.45,0,0,1-4.2-.08,30.52,30.52,0,0,1-15.46-6,35.69,35.69,0,0,1-3.2-2.7,35.64,35.64,0,0,1-2.74-3.16,30.47,30.47,0,0,1,2.95-40.36Zm-2.86,40.29a33.9,33.9,0,0,0,2.75,3.12,33.78,33.78,0,0,0,3.2,2.67,27.93,27.93,0,0,0,7.31,3.94,29.9,29.9,0,0,0,8.08,1.78,30.25,30.25,0,0,0,4.15,0,26.85,26.85,0,0,0,4.1-.5,29.85,29.85,0,0,0,14.5-7.47l.15-.14.21,0,15.16,2.12-.54.8-7.62-13.07-.15-.25.11-.27a29.87,29.87,0,0,0-1.71-26A31.24,31.24,0,0,0,319.43,40a29.76,29.76,0,0,0-12.5-4.94,29.94,29.94,0,0,0-28.14,48.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.4,68.42V72.2a2.79,2.79,0,0,1-2.85,2.85,2.86,2.86,0,0,1-2.85-2.85v-6c0-.06.06-.06.06-.12s-.06-.06-.06-.11a2.93,2.93,0,0,1,2.85-2.85,6.52,6.52,0,1,0,0-13,6.42,6.42,0,0,0-5.58,3.2,2.89,2.89,0,0,1-4,1,2.84,2.84,0,0,1-1-3.9,12.22,12.22,0,1,1,13.37,18Zm0,12.73v1a2.78,2.78,0,0,1-2.85,2.85,2.85,2.85,0,0,1-2.85-2.85v-1a2.89,2.89,0,0,1,2.85-2.85A2.82,2.82,0,0,1,305.4,81.15Z",
    style: {
      fill: "#F3C37D"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.70152ed65aa49e37d3092be838241984.svg";
export { ForwardRef as ReactComponent };